import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ArrowRight } from 'lucide-react';
export function PricingCTA() {
  return <motion.section initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 mt-8" id="pricing" data-id="element-90">
      <div className="bg-[#1A1A1A] text-[#FAFAF7] rounded-2xl p-8 md:p-12 lg:p-16 shadow-2xl text-center relative overflow-hidden" data-id="element-91">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#1B6B3A] opacity-10 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2" data-id="element-92"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#1B6B3A] opacity-10 rounded-full blur-3xl transform translate-x-1/2 translate-y-1/2" data-id="element-93"></div>

        <div className="relative z-10" data-id="element-94">
          <div className="inline-flex items-center justify-center p-3 lg:p-4 bg-[#1B6B3A]/20 rounded-full mb-6 lg:mb-8" data-id="element-95">
            <Lock className="w-8 h-8 lg:w-10 lg:h-10 text-[#1B6B3A]" data-id="element-96" />
          </div>

          <div className="mb-8 lg:mb-10 max-w-xs mx-auto" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/3Ki6N1nPFH2Me5zDJVqj5m/heylloyd-image-1770951032391.png" alt="Closing Number Lock Product" className="w-full h-auto rounded-lg shadow-lg" data-id="element-98" />
          </div>

          <div className="inline-block bg-[#1B6B3A] text-white px-3 py-1 rounded-sm text-xs font-bold uppercase tracking-wide mb-3" data-id="element-99">
            Launch Price
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-4" data-id="element-100">
            $6.36{' '}
            <span className="text-xl lg:text-2xl font-normal text-gray-400 align-middle line-through" data-id="element-101">
              $19
            </span>
            <span className="text-xl lg:text-2xl font-normal text-gray-400 align-middle" data-id="element-102">
              {' '}
              (one-time)
            </span>
          </h2>
          <p className="text-base lg:text-lg text-[#1B6B3A] font-semibold mb-2" data-id="element-103">
            You save $12.64 — 66% off
          </p>

          <p className="text-lg lg:text-xl text-gray-300 mb-10 lg:mb-12 max-w-lg mx-auto" data-id="element-104">
            If it prevents one last-minute scramble, it paid for itself.
          </p>

          <div className="mb-10 lg:mb-12 text-left bg-white/5 p-6 lg:p-8 rounded-lg border border-white/10 max-w-lg mx-auto" data-id="element-105">
            <p className="text-lg lg:text-xl mb-4 leading-relaxed" data-id="element-106">
              If you want to walk into closing with a stable number—or at least
              no surprises—you need a coordination checklist.
            </p>
            <p className="font-bold text-white text-lg lg:text-xl" data-id="element-107">
              Get Closing Number Lock and run the 7‑3‑1 confirmation calendar
              for your closing date.
            </p>
          </div>

          <a href="https://www.betterbysteps.com/cart/44196553031773:1" target="_blank" rel="noopener noreferrer" className="group w-full md:w-auto bg-[#1B6B3A] hover:bg-[#165930] text-white text-xl lg:text-2xl font-bold py-4 lg:py-5 px-8 lg:px-12 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02] flex items-center justify-center gap-3 mx-auto" data-id="element-108">
            <span data-id="element-109">Get Closing Number Lock</span>
            <ArrowRight className="w-5 h-5 lg:w-6 lg:h-6 group-hover:translate-x-1 transition-transform" data-id="element-110" />
          </a>

          <p className="mt-6 lg:mt-8 text-sm lg:text-base text-gray-500" data-id="element-111">
            Secure checkout • Instant digital delivery
          </p>
        </div>
      </div>
    </motion.section>;
}